import { render, staticRenderFns } from "./love.vue?vue&type=template&id=42bc1660&scoped=true&"
import script from "./love.vue?vue&type=script&lang=js&"
export * from "./love.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bc1660",
  null
  
)

export default component.exports